export class Plan {
  id: string;
  name: string;
  code: string;
  price: number;
  billingCycle: string;
  description: string;
  operatorId: string;
  createdAt: number;
  updatedAt: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/bill/type-setup/plan.ts